import { Typography, useTheme } from '@mui/material';

export const Text = ({
  text,
  fontSize,
  variant = 'body1',
  noWrap = false,
  sx,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Typography
      variant={variant}
      sx={{
        fontSize,
        color: theme.palette.secondary.main,
        ...sx,
      }}
      noWrap={noWrap}
      {...rest}
    >
      {text}
    </Typography>
  );
};
